
import moment from "moment-timezone";
import { getTimezoneByRole } from "./timezoneHelper";

export const convertTimeToUTC = (dateTimeString, role = 'admin') => {
  const tz = getTimezoneByRole(role);
  return moment.utc(dateTimeString).tz(tz).format("YYYY-MM-DD HH:mm");
}
